import * as React from "react";

export const Padlock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="#ccc"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M17 11V7a5 5 0 0 0-10 0v4a5 5 0 0 0-2 4v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a5 5 0 0 0-2-4zm-4-4V7a3 3 0 1 0-6 0v4h6z" />
    <circle cx="12" cy="16" r="2" />
  </svg>
);
